<section class="overview" *ngIf="report$ | async as report">
    <report-form-feature *ngIf="report != undefined" [report]="report" (reportSubmit)="onSubmit($event)">
    </report-form-feature>
</section>